module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAAB/CAYAAADGvR0TAAABQElEQVR4nO3RQRHAIADAsDEr4N8ZGkAGjyYKetex5zofSf/rAN4xP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP8z8MPPDzA8zP+wCt+UDMQ6X/JkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Images/shape/rectangle.png
// module id = 645
// module chunks = 7